// extracted by mini-css-extract-plugin
export default {"container":"tasks-open_page_container__7iBUp","headerContainer":"tasks-open_page_headerContainer__L3mjA"};